import { render, staticRenderFns } from "./Wp_my_child_search.vue?vue&type=template&id=74b9f925&scoped=true&"
import script from "./Wp_my_child_search.vue?vue&type=script&lang=js&"
export * from "./Wp_my_child_search.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74b9f925",
  null
  
)

export default component.exports